import { event } from "jquery";
import { request } from "../../main.top";
// DOWNLOAD RESEARCH POPUP

function saveNewWebcastLog(reqBody) {
    const reqBodyWebcastLink = reqBody.webcastLink;

    request("POST", ajaxurl, reqBody, function (req) {
        const result = JSON.parse(req);

        if (result.success === true) {
            const expireTime = new Date(new Date(new Date()).setMinutes(new Date().getMinutes() + 30)).toUTCString();
            document.cookie = "name=" + reqBody.name + ";path=/" + expireTime;
            document.cookie = "email=" + reqBody.email + ";path=/" + expireTime;
            document.cookie = "companyName=" + reqBody.company + ";path=/" + expireTime;
            document.cookie = "phone=" + reqBody.phone + ";path=/" + expireTime;

            // localStorage
            const person = {
                name: reqBody.name,
                email: reqBody.email,
                company: reqBody.company,
                phone: reqBody.phone,
            };

            window.localStorage.setItem("userInfoCookies", JSON.stringify(person));
            console.log("resul2 => ", result);

            // var form = $(`<form action="${result.redirectTo}" method="post" style="display: none !important;">
            //                 <input type="text" name="user" value="${encodeURIComponent(result.user)}" />
            //                 <input type="text" name="pass" value="${encodeURIComponent(result.password)}" />
            //                 <input type="text" name="webcastLink" value="${result.webcastLink}" />
            //             </form>`);
            // $("body").append(form);
            // console.log("form => ", form);
            // form.submit();
            window.open(
                reqBodyWebcastLink,
                reqBodyWebcastLink.includes('calendar.google') ? '_blank' : '_self'
            );
        }
    });
}

function open(url, inNewTab = false) {
    window.open(url, inNewTab ? "_blank" : "_self").focus();
}

export function openResearchPopup(webcastName, webcastLink, webcastAccessPopup = webcastAccessPopup) {
    webcastAccessPopup = document.getElementById("signInPopup");
    if (!webcastAccessPopup) return;

    /** @type {HTMLFormElement} */
    const researchForm = webcastAccessPopup.querySelector(".card > form.signInEvent");

    const popupName = webcastAccessPopup.querySelector('input[name="name"]');
    const popupEmail = webcastAccessPopup.querySelector('input[name="email"]');
    const popupCompany = webcastAccessPopup.querySelector('input[name="company"]');
    const popupPhone = webcastAccessPopup.querySelector('input[name="phone"]');

    researchForm.addEventListener("submit", function (event) {
        event.preventDefault();
        let parametersURL = window.location.href.split("/");
        let parametersLast = parametersURL[parametersURL.length - 1];

        const body = {
            action: "mziq_save_webcast_access",
            name: popupName.value,
            email: popupEmail.value,
            company: popupCompany.value,
            phone: popupPhone.value,
            webcastName: popupWebcastName.value,
            webcastLink: popupWebcastLink.value,
            webcastParameters: parametersLast,
        };


        saveNewWebcastLog(body);
    });

    const popupWebcastName = webcastAccessPopup.querySelector('input[name="webCastName"]');
    const popupWebcastLink = webcastAccessPopup.querySelector('input[name="webCastLink"]');

    popupWebcastName.setAttribute("value", webcastName);
    popupWebcastLink.setAttribute("value", webcastLink);

    if (document.body.classList.contains("temporaryLoggedIn")) {
        const userInfoLocalStorage = JSON.parse(window.localStorage.getItem("userInfoCookies"));

        const body = {
            action: "mziq_save_webcast_access",
            name: userInfoLocalStorage.name,
            email: userInfoLocalStorage.email,
            company: userInfoLocalStorage.company,
            phone: userInfoLocalStorage.phone,
            webcastName: popupWebcastName.value,
            webcastLink: popupWebcastLink.value,
        };
        saveNewWebcastLog(body);
        open(webcastLink);
    } else {
        eventSignInToggle.click();
    }
}

window.openResearchPopup = openResearchPopup;